import FileThumbnail from './FileThumbnail';
import './FileThumbnail.scss';

export default FileThumbnail;
